import lodoppo from "@/store/entities/Common/lodoppo";
class PrintFormat{
    //处理已有模板
  lodopinfo(val) {
    if (val.length <= 0) {
      return;
    }
    let lodoplist: Array<lodoppo> = [];
    let vallist = val.split(");");
    if (vallist.length > 0) {
      let sl: number = 0;
      let el: number = 0;
      vallist.forEach((ele) => {
        let str = ele.replace("\n", "").replace('"', "").replace('"', "");
        if (str != undefined && str != "" && str != null) {
          sl = str.indexOf("LODOP");
          el = str.indexOf("(");
          let l: lodoppo = new lodoppo();
          l.key = str.substring(0, el);
          str = str.substring(el + 1);
          switch (l.key) {
            case "LODOP.PRINT_INIT": //打印初始化PRINT_INIT(strTaskName)
              l.name = str;
              break;
            case "LODOP.PRINT_INITA": //(扩展型)打印初始化(Top,Left,Width,Height,strPrintName)
              let al = str.split(",");
              l.intTop = Number(al[0]);
              l.intLeft = Number(al[1]);
              l.intWidth = Number(al[2]);
              l.intHeight = Number(al[3]);
              l.name = al[4].replace("\"","");
              break;
            case "LODOP.SET_PRINT_PAGESIZE": //设定纸张大小(intOrient, PageWidth,PageHeight,strPageName)
              let pal = str.split(",");
              l.intOrient = Number(pal[0]);
              l.intPageWidth = Number(pal[1]);
              l.intPageHeight = Number(pal[2]);
              l.strPageName = al[3].replace("\"","");
              break;
            case "LODOP.ADD_PRINT_HTM": //增加超文本打印项(普通模式)(Top,Left,Width,Height,strHtmlContent)
              el = str.indexOf(",");
              let htop = str.substring(sl, el);
              l.intTop = Number(htop);
              sl = sl + htop.length + 1;
              el = str.indexOf(",", sl);
              let hleft = str.substring(sl, el);
              l.intLeft = Number(hleft);
              sl = sl + hleft.length + 1;
              el = str.indexOf(",", sl);
              let hwidth = str.substring(sl, el);
              l.intWidth = Number(hwidth);
              sl = sl + hwidth.length + 1;
              el = str.indexOf(",", sl);
              let hheight = str.substring(sl, el);
              l.intHeight = Number(hheight);
              sl = sl + hheight.length + 2;
              let hval = str.substring(sl, str.length - 3);
              l.strContent = hval.replace("\"","");
              break;
            case "LODOP.ADD_PRINT_TEXT": //增加纯文本打印项(Top,Left,Width,Height,strContent)
              let text = str.split(",");
              l.intTop = Number(text[0]);
              l.intLeft = Number(text[1]);
              l.intWidth = Number(text[2]);
              l.intHeight = Number(text[3]);
              l.strContent = text[4].replace('\"', "");
              break;
            case "LODOP.ADD_PRINT_IMAGE": //增加图片打印项(Top,Left,Width,Height,strHtmlContent)
              let image = str.split(",");
              l.intTop = Number(image[0]);
              l.intLeft = Number(image[1]);
              l.intWidth = Number(image[2]);
              l.intHeight = Number(image[3]);
              l.strContent = image[4].replace("\"","");
              break;
            case "LODOP.ADD_PRINT_RECT": //增加矩形线ADD_PRINT_RECT(Top, Left, Width, Height,intLineStyle, intLineWidth)
              let rect = str.split(",");
              l.intTop = Number(rect[0]);
              l.intLeft = Number(rect[1]);
              l.intWidth = Number(rect[2]);
              l.intHeight = Number(rect[3]);
              l.intLineStyle = Number(rect[4]);
              l.intLineWidth = Number(rect[5]);
              break;
            case "LODOP.ADD_PRINT_ELLIPSE": //增加椭圆线(Top, Left,Width, Height, intLineStyle, intLineWidth)
              let ellipse = str.split(",");
              l.intTop = Number(ellipse[0]);
              l.intLeft = Number(ellipse[1]);
              l.intWidth = Number(ellipse[2]);
              l.intHeight = Number(ellipse[3]);
              l.intLineStyle = Number(ellipse[4]);
              l.intLineWidth = Number(ellipse[5]);
              break;
            case "LODOP.ADD_PRINT_LINE": //增加直线(Top1,Left1, Top2, Left2,intLineStyle, intLineWidth),用intWidth,intHeight代替Top2,Left2
              let line = str.split(",");
              l.intTop = Number(line[0]);
              l.intLeft = Number(line[1]);
              l.intWidth = Number(line[2]);
              l.intHeight = Number(line[3]);
              l.intLineStyle = Number(line[4]);
              l.intLineWidth = Number(line[5]);
              break;
            case "LODOP.ADD_PRINT_TEXTA": //(扩展型)增加纯文本打印项(strItemName,Top,Left,Width,Height,strContent)
              let texta = str.split(",");
              l.name = texta[0];
              l.intTop = Number(texta[1]);
              l.intLeft = Number(texta[2]);
              l.intWidth = Number(texta[3]);
              l.intHeight = Number(texta[4]);
              l.strContent = texta[5].replace("\"","");
              break;
            case "LODOP.ADD_PRINT_BARCODE": //增加条形码(Top, Left,Width, Height, CodeType, CodeValue)
              let barcode = str.split(",");
              l.intTop = Number(barcode[0]);
              l.intLeft = Number(barcode[1]);
              l.intWidth = Number(barcode[2]);
              l.intHeight = Number(barcode[3]);
              l.codeType = barcode[4].replace("\"","");
              l.codeValue = barcode[5].replace("\"","");
              break;
            case "LODOP.ADD_PRINT_CHART": //增加图表(Top, Left,Width, Height, ChartType, strHtml)
              let chart = str.split(",");
              l.intTop = Number(chart[0]);
              l.intLeft = Number(chart[1]);
              l.intWidth = Number(chart[2]);
              l.intHeight = Number(chart[3]);
              l.chartType = chart[4].replace("\"","");
              l.strContent = chart[5].replace("\"",""); //后续需要再处理，可能会有多分隔
              break;
            case "LODOP.ADD_PRINT_TABLE": //增加表格打印项（超文本模式）(Top,Left,Width,Height,strHtml)
              el = str.indexOf(",");
              let tatop = str.substring(sl, el);
              l.intTop = Number(tatop);
              sl = sl + 1 + tatop.length;
              el = str.indexOf(",", sl);
              let taleft = str.substring(sl, el);
              l.intLeft = Number(taleft);
              sl = sl + taleft.length + 1;
              el = str.indexOf(",", sl);
              let tawidth = str.substring(sl, el);
              l.intWidth = Number(tawidth);
              sl = sl + tawidth.length + 1;
              el = str.indexOf(",", sl);
              let taheight = str.substring(sl, el);
              l.intHeight = Number(taheight);
              sl = sl + taheight.length + 1;
              let taval = str.substring(sl, str.length - 3);
              l.strContent = taval.replace("\"","");
              break;
            case "LODOP.ADD_PRINT_URL": //增加超文本打印项（URL模式）(Top,Left,Width,Height,strURL)
              let url = str.split(",");
              l.intTop = Number(url[0]);
              l.intLeft = Number(url[1]);
              l.intWidth = Number(url[2]);
              l.intHeight = Number(url[3]);
              l.strURL = url[4].replace("\"","");
              break;
            case "LODOP.ADD_PRINT_SHAPE": //(扩展型)增加图形(intShapeType, Top, Left,Width,Height,intLineStyle,intLineWidth, varColor)
              let sal = str.split(",");
              l.intShapeType = Number(sal[0]);
              l.intTop = Number(sal[1]);
              l.intLeft = Number(sal[2]);
              l.intWidth = Number(sal[3]);
              l.intHeight = Number(sal[4]);
              l.intLineStyle = Number(sal[5]);
              l.intLineWidth = Number(sal[6]);
              l.intColor = sal[7].replace("\"","");
              break;
            case "LODOP.SET_PRINT_STYLE": //设置打印项风格(strStyleName,varStyleValue)
              let stal = str.split(",");
              l.strStyleName = stal[0].replace("\"","");
              l.varStyleValue = stal[1].replace("\"","");
              break;
            case "LODOP.SET_PRINT_STYLEA": //(扩展型)设置打印项风格A(varItemNameID, strStyleName,varStyleValue)
              let stala = str.replace('"', "").split(",");
              l.varItemNameID = stala[0];
              l.strStyleName = stala[1];
              l.varStyleValue = stala[2];
              break;
            case "LODOP.ADD_PRINT_HTML": //增加超文本打印项(图形模式)(Top,Left,Width,Height, strHtmlContent)
              let html = str.split(",");
              l.intTop = Number(html[0]);
              l.intLeft = Number(html[1]);
              l.intWidth = Number(html[2]);
              l.intHeight = Number(html[3]);
              l.strContent = html[4]; //分隔可能存在问题
              break;
            case "LODOP.ADD_PRINT_TBURL": //(扩展型)增加表格打印项（URL模式）(Top,Left,Width,Height,strURL)
              let tburl = str.split(",");
              l.intTop = Number(tburl[0]);
              l.intLeft = Number(tburl[1]);
              l.intWidth = Number(tburl[2]);
              l.intHeight = Number(tburl[3]);
              l.strURL = tburl[4];
              break;
          }
          lodoplist.push(l);
        }
      });
    }
    return lodoplist;
  }
}
const printformat = new PrintFormat();
export default printformat;